import { Station } from '@mi-front/core';
import { Card, CardContent } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useHistory } from 'react-router';
import { useStatusViewContext } from '../../context/StatusViewContext';

export function StatusCard({
  station,
  innerRef,
  children,
}: PropsWithChildren<{
  station: Station;
  innerRef: (node?: Element | null) => void;
}>) {
  const history = useHistory();
  const { compact } = useStatusViewContext();

  return (
    <Card
      ref={innerRef}
      className="status-card"
      data-testid="station-status-card"
      data-station-name={station.name}
      elevation={2}
      sx={{
        mb: compact ? 0 : 2, // No margin in grid (spacing handled by Grid), margin in list
        cursor: 'pointer',
        border: '1px solid transparent',
        transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
        '&:hover': {
          boxShadow: 4,
          borderColor: 'primary.main',
        },
        height: compact ? '100%' : 'auto', // Full height in grid
        // When favorite is inactive, hide until card hover (pointer-events off when hidden).
        // Favorite (active) toggle has no --inactive class and stays visible.
        '& .status-card__favorite-toggle--inactive': {
          opacity: 0,
          pointerEvents: 'none',
          transition: 'opacity 0.1s ease-in-out',
        },
        '&:hover .status-card__favorite-toggle--inactive': {
          opacity: 1,
          pointerEvents: 'auto',
        },
      }}
      onClick={() => {
        history.push(`/logger/s/${station.slug}`);
      }}
    >
      <CardContent sx={{ p: compact ? 1.5 : 2 }}>{children}</CardContent>
    </Card>
  );
}
